import { ROLES } from "../utils/sesion";

// Debe coincidir con ROLES del backend (db/models/user.js)
export const OPCIONES_ROL = [
  { value: ROLES.DIGITADOR, label: "Digitador" },
  { value: ROLES.ADMIN, label: "Administrador" },
  { value: ROLES.SUPERADMIN, label: "Superadministrador" },
];

export const etiquetaRol = (rol) => OPCIONES_ROL.find((r) => r.value === rol)?.label ?? rol;
